import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({ standalone: false,
  selector: 'vfa-cp-session-expired',
  templateUrl: './session-expired.component.html'
})
export class SessionExpiredComponent {
  constructor(public router: Router) {
    
  }
}

